<template>
	<b-form
		ref="form"
		@submit.prevent="setEngineerPost"
	>
		<b-form-group>
			<v-select
				v-model="component"
				label="FullName"
				:options="engineers"
			/>
		</b-form-group>

		<b-button
			type="submit"
			variant="info"
		>Set Engineer</b-button>

	</b-form>
</template>

<script>
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import AccountService from "@/api-services/account.service";

export default {
	name: "AddAlloction",

	// things we want to use
	components: {
		VSelect
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			component: null,
			engineers: []
		};
	},

	created() {
		this.fetchEngineers();
	},

	// things we do to data
	methods: {
		setEngineerPost() {
			this.$emit("addAllocation", this.component);
		},

		fetchEngineers() {
			AccountService.getAll().then((response) => {
				this.engineers = response.data;
			});
		},
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/add-allocation.vue